<div 
    class="button-icon" 
    [ngClass]="'button-icon--' + iconPlacement">
    <div class="button-icon__icon">
        <fa-icon [icon]="icon"></fa-icon>
        <fa-icon class="button-icon__arrow" icon="angle-down" size="sm" *ngIf="arrow === 'down'"></fa-icon>
        <fa-icon class="button-icon__arrow" icon="angle-up" size="sm" *ngIf="arrow === 'up'"></fa-icon>
    </div>
    
    <div
        class="button-icon__label"
        [ngClass]="{
            'button-icon__label--light': color === 'light',
            'button-icon__label--dark': color === 'dark'
        }">
        {{ label }}
    </div>
</div>